import React, { useEffect, useState } from "react"
import { ColorPicker, Switch, Textarea } from "@lib/components"
import Quill from "quill";
import { 
    SettingsFormGroup,
    SettingsSwitchContainer,
    SettingsFormLabelLeftContainer,
    SettingSwitchWithTextContainer,
    SettingsFormGroupInput,
    SettingsFormInputContainer,
    SettingsFormLabelContainer,
    SettingsFormLabelRightContainer,
    SalesTaxesAddButton,
    OpeningHoursContainer,
    OpeningHoursCard,
    OpeningHoursCardWrapper,
    EligibleItem,
    EligibleItemContentWrapper,
    EligibleItemIconWrapper,
    EligibleItemsContainer,
    OptionalText,
    SettingsCustomOption,
    SettingsCustomOptionsContainer,
    OpeningHoursCardScheduleWrapper,
    SettingsActionButtonWrapper,
    SettingsMenuContainer,
    SettingsMenuRow,
    SettingsMenuRowItem,
    SettingsMenuRowWrapper,
    SettingsActionButtonContainer
    
} from "."
import { 
    IconCalendar,
    IconHelp,
    IconPlusRed,
    IconEligibleItemCheck,
    IconArrowForward,
    IconEligibleItemCheckDefault,
    IconGreenEllipse,
    IconRedEllipse,
    IconClose,
    IconCheck,
    IconHour,
    IconTerms,
    IconWrapperRounded,
    IconPolicy,
    IconCookie,
    IconHelpV2
} from "../../../../components/v2/icons"
import styled from "styled-components"
import { useStores } from "../../../../../mobx/useStores"
import { 
    PromoCard,
    PromoCardContainer,
    PromoCardContent,
    PromoCardStatus,
    PromoCardTag
} from "./promo-codes"
import { HTMLEditor } from "../../../../components/html-editor"
import { templateText } from "../settings/forms/system/terms";
import { cookieTemplateText } from "../settings/forms/system/cookie-policy";
import { CoreUtils } from "@lib/common";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { UI } from "../../../../../core/ui";
import { FastField } from "formik";
import { RotateLoader } from "@lib/components"
import { SimpleEditor } from "./email-notification";
const TIMESLOTS = [
    {day: 'Monday', hours: '9:00 - 14:00'},
    {day: 'Tuesday', hours: '24 Hours'},
    {day: 'Wednesday', hours: '24 Hours'},
]

export const SettingsFormGroupEditor = styled('div')`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
width: 100%;
& #text-editor, & .ql-container {
    width: 100%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-color: #dfdfdf;
    height: 300px;

    & p {
        border: none;
        padding: 0;
    }
}
& .ql-toolbar.ql-snow {
    width: 100%;
  
    border-top-left-radius: 8px;
    border-color: #dfdfdf;
    border-top-right-radius: 8px;
    
}
& p {
    color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 171.429% */
padding-bottom: 16px;
width: 100%;
border-bottom: 1px dashed var(--Secondary-Light-Grey-1, #DFDFDF);
}

`

const PolicyButtonContainer = styled.div`
display: flex;
align-items: flex-start;
gap: 24px;
align-self: stretch;
margin-top: 24px;
margin-bottom: 24px;

@media (min-width: 768px) {
    width: 40%;
    align-self: end;
}
`
export const CookieColorsContainer = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 16px;
align-self: stretch;

`
export const CookieColorsRow= styled.div`
display: flex;
align-items: center;
gap: 24px;
align-self: stretch;


& > * {
    flex: 1 0 0;
    color: var(--Secondary-Dark-Grey-1, #4B4F5E);
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 171.429% */
}
`

export const CookieColorPickerWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 8px;
flex: 1 0 0;

`

export const CookieColorPickerContent = styled.div`
display: flex;
height: 48px;
padding: 8px;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 4px;
border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-White, #FEFEFE);

&  div[class^="colorpicker"] {
    padding: 0;
    width: 32px;
    height: 32px;
}
&  div[class^="colorpicker__DropWrapper"] {
    left: -55px;
}

&.w-100px {
    width: 100px;
    padding: 4px;
    height: 40px;
    &  div[class^="colorpicker"] {
        width: 90px;
    }
}
`
const privacyPolicyTemplate = `<p><strong class="ql-size-large">Privacy Policy of&nbsp;&lt;&lt;RESTAURANT NAME&gt;&gt;</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p><strong>&lt;&lt;RESTAURANT NAME&gt;&gt;</strong>&nbsp;operates the&nbsp;<strong>&lt;&lt;WEBSITE NAME&gt;&gt;</strong>&nbsp;website, which provides the SERVICE.</p><p><br></p><p>This page is used to inform website visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service, the&nbsp;<strong>&lt;&lt;WEBSITE NAME&gt;&gt;</strong>&nbsp;website.</p><p><br></p><p>If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p><p><br></p><p>The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at<strong>&lt;&lt;WEBSITE URL&gt;&gt;</strong>, unless otherwise defined in this Privacy Policy.</p><p><br></p><p><strong class="ql-size-large">Information Collection and Use</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to your name, phone number, and postal address. The information that we collect will be used to contact or identify you.</p><p><br></p><p><strong class="ql-size-large">Log Data</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>We want to inform you that whenever you visit our Service, we collect information that your browser sends to us which is called Log Data. This Log Data may include information such as your computer's Internet Protocol (&ldquo;IP&rdquo;) address, browser version, pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p><p><br></p><p><strong class="ql-size-large">Cookies</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>Cookies are files with a small amount of data that is commonly used as an anonymous unique identifier. These are sent to your browser from the website that you visit and are stored on your computer's hard drive.</p><p>Our website uses these &ldquo;cookies&rdquo; to collect information and to improve our Service. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your computer. If you choose to refuse our cookies, you may not be able to use some portions of our Service.</p><p><br></p><p><strong class="ql-size-large">Service Providers</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>We may employ third-party companies and individuals due to the following reasons:</p><ul><li>To facilitate our Service;</li><li>To provide the Service on our behalf;</li><li>To perform Service-related services; or</li><li>To assist us in analyzing how our Service is used.</li></ul><p>We want to inform our Service users that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p><p><br></p><p><strong class="ql-size-large">Security</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>We value your trust in providing us with your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p><p><br></p><p><strong class="ql-size-large">Links to Other Sites</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>Our Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p><p><br></p><p><strong class="ql-size-large">Children's Privacy</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>Our Services do not address anyone under the age of 13. We do not knowingly collect personal identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do the necessary actions.</p><p><br></p><p><strong class="ql-size-large">Changes to This Privacy Policy</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>We may update our Privacy Policy from time to time. Thus, we advise you to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p><p><br></p><p><strong class="ql-size-large">Contact Us</strong></p><hr class="ql-hr" style="height:0;margin-top:10px;margin-bottom:10px"><p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us.</p><p><br></p>`;

interface FormValues {
	terms: T.Schema.Restaurant.RestaurantSchema["settings"]["terms"];
    privacy: T.Schema.Restaurant.RestaurantSchema["settings"]["privacy"];
    cookie: T.Schema.Restaurant.RestaurantSchema["settings"]["cookie"];
}
export const SettingsPoliciesAgreements = (props: any) => {
    const store = useStores()
    const {setActiveMobileMenu, setActiveMobileModal } = store;
    const { activeMobileMenu, activeMobileModal } = props;
    const [quill, setQuill] =useState<Quill | null>(null);
    const [backgroundColor, setBackgroundColor] = useState('#000000');
    const [textColor, setTextColor] = useState('#ffffff');

    const r = store.restaurant!;

    let initialValues =  {
        terms: r.settings.terms,
        privacy: r.settings.privacy,
        cookie: r.settings.cookie
    }
    return (
        <div style={{paddingTop: 16, paddingBottom: 83, width: '100%'}}>

            <RestaurantForm<FormValues>
                submit={async (r, values) => {
                    r.settings.terms = values.terms;
                    r.settings.privacy = values.privacy;
                    r.settings.cookie = values.cookie;
                   let update = { $set: { "settings.terms": values.terms } } as any;
                   if(activeMobileMenu === 'privacy-policy') {
                    update = { $set: { "settings.privacy": values.privacy } };
                   }
                   else if(activeMobileMenu === 'cookie-policy') {
                    update = { $set: { "settings.cookie": values.cookie } };
                   }
                    return { r, update };
                }}
                initialValues={initialValues}
                onError={() => UI.notification.error("An error occurred")}
                onSuccessMessage="Settings Updated"
            >
                {({ form, error }) => {
                    const { isSubmitting, setFieldValue } = form;
                    return (<>
             {activeMobileMenu == 'policies-&-agreements' && <SettingsMenuContainer>
                <SettingsMenuRow onClick={() => store.setActiveMobileMenu('terms-&-conditions', 'policies-&-agreements')}>
                    <SettingsMenuRowWrapper>
                        <SettingsMenuRowItem>
                            <IconWrapperRounded className='icon-wrapper-rounded'>
                                <IconTerms />
                            </IconWrapperRounded>
                            <p>Terms & Conditions</p>
                            <IconArrowForward />
                        </SettingsMenuRowItem>
                    </SettingsMenuRowWrapper>
                </SettingsMenuRow>
                <SettingsMenuRow onClick={() => store.setActiveMobileMenu('privacy-policy', 'policies-&-agreements')}>
                    <SettingsMenuRowWrapper>
                        <SettingsMenuRowItem>
                            <IconWrapperRounded className='icon-wrapper-rounded'>
                                <IconPolicy />
                            </IconWrapperRounded>
                            <p>Privacy Policy</p>
                            <IconArrowForward />
                        </SettingsMenuRowItem>
                    </SettingsMenuRowWrapper>
                </SettingsMenuRow>
                <SettingsMenuRow onClick={() => store.setActiveMobileMenu('cookie-policy', 'policies-&-agreements')}>
                    <SettingsMenuRowWrapper>
                        <SettingsMenuRowItem>
                            <IconWrapperRounded className='icon-wrapper-rounded'>
                                <IconCookie />
                            </IconWrapperRounded>
                            <p>Cookie Policy</p>
                            <IconArrowForward />
                        </SettingsMenuRowItem>
                    </SettingsMenuRowWrapper>
                </SettingsMenuRow>
            </SettingsMenuContainer>}

            {(activeMobileMenu == 'terms-&-conditions' || activeMobileMenu == 'privacy-policy' || activeMobileMenu == 'cookie-policy' ) && 
            <SettingsFormGroupEditor>
                <SimpleEditor 
                    id="text-editor"
                    initialValue={(activeMobileMenu == 'terms-&-conditions' ? form.values.terms : activeMobileMenu == 'privacy-policy' ?  form.values.privacy : ((form.values.cookie && form.values.cookie.content) || ''))}
                    onChange={(val) => {
                        if(activeMobileMenu == 'terms-&-conditions') {
                            setFieldValue('terms', val)
                        } else if(activeMobileMenu == 'privacy-policy') {
                            setFieldValue('privacy', val)
                        } else {
                            setFieldValue('cookie.content', val)
                        }
                    }} />
                <PolicyButtonContainer>
                    <SettingsActionButtonWrapper variant="white" position='relative' noborder nopadding>
                        <button
                            type="button" 
                            onClick={() => { 
                                const editor = document.querySelector('#text-editor')
                                if(editor) {
                                    Quill.find(editor).clipboard.dangerouslyPasteHTML(
                                        activeMobileMenu == 'terms-&-conditions' ? 
                                        templateText: activeMobileMenu === 'privacy-policy' ? privacyPolicyTemplate : cookieTemplateText)
                                }
                                }}> Use Template</button>
                    </SettingsActionButtonWrapper>
                    <SettingsActionButtonWrapper
                        style={{
                            borderRadius: 4,
                            border: `1px solid var(--Secondary-Dark-Grey-1, #4B4F5E`}}
                        variant="black" position='relative'  nopadding>
                        <button type="button"
                         onClick={() => {
                            const editor = document.querySelector('#text-editor')
                            if(editor) {
                                Quill.find(editor).setText('')
                            }
                            }}> Clear</button>
                    </SettingsActionButtonWrapper>
                </PolicyButtonContainer>
                <p>Please click Save before moving to another tab.</p>
            </SettingsFormGroupEditor>}

            {activeMobileMenu == 'cookie-policy' &&  <SettingsFormGroup>
                <SettingsFormGroupInput className="cookie-consent-desktop">
                    <SettingsFormLabelContainer className="cookie-consent-label">
                        <SettingsFormLabelLeftContainer>Cookie Consent Banner Colors</SettingsFormLabelLeftContainer>
                        <SettingsFormLabelRightContainer><IconHelpV2 /></SettingsFormLabelRightContainer>
                    </SettingsFormLabelContainer>
                    <CookieColorsContainer className="cookie-consent-color">
                        <CookieColorsRow>
                            <p>Background</p>
                            <CookieColorPickerWrapper>
                            <FastField
									name="cookie.banner_color"
									render={({ field }: any) => (
                                        <CookieColorPickerContent>
                                        <ColorPicker
                                            color={field.value}
                                            onChange={(color) => {
                                                setFieldValue(
                                                    "cookie.banner_color",
                                                    color
                                                )
                                                
                                            }}
                                            />
                                                {'#'+CoreUtils.colors.rgbToHex(field.value)}
                                        </CookieColorPickerContent>
									
									)}
								/>
                            
                            </CookieColorPickerWrapper>
                        </CookieColorsRow>
                    </CookieColorsContainer>
                    <CookieColorsContainer className="cookie-consent-color">
                        <CookieColorsRow>
                            <p>Text</p>
                            <CookieColorPickerWrapper>
                            <FastField
                                name="cookie.text_color"
                                render={({ field }: any) => (
                                    <CookieColorPickerContent>
                                    <ColorPicker
                                        color={field.value}
                                        onChange={(color) => {
                                            setFieldValue(
                                                "cookie.text_color",
                                                color
                                            )
                                        }}
                                        />
                                    {'#'+CoreUtils.colors.rgbToHex(field.value)}
                                    </CookieColorPickerContent>
                                
                                )}
							/>
                            </CookieColorPickerWrapper>
                        </CookieColorsRow>
                    </CookieColorsContainer>
                </SettingsFormGroupInput>
                <SettingsFormGroupInput>
                    <SettingsFormLabelContainer>
                        <SettingsFormLabelLeftContainer>Cookie Consent Banner Text</SettingsFormLabelLeftContainer>
                    </SettingsFormLabelContainer>
                    <SettingsFormInputContainer>
                        <FastField
                            name="cookie.banner_text"
                            render={({ field }: any) => (
                                <Textarea
                                    {...field}
                                    value={field.value}
                                />
                            )}
                        />
                    </SettingsFormInputContainer>
                </SettingsFormGroupInput>
                <SettingsFormGroupInput>
                    <SettingsFormLabelContainer>
                        <SettingsFormLabelLeftContainer>Cookie Consent Banner Cookie Policy Link Text</SettingsFormLabelLeftContainer>
                    </SettingsFormLabelContainer>
                    <SettingsFormInputContainer>
                    <FastField
                        name="cookie.link_text"
                        render={({ field }: any) => (
                            <input {...field} value={field.value} />
                        )}
                    />
                    </SettingsFormInputContainer>
                </SettingsFormGroupInput>
                <SettingsFormGroupInput>
                    <SettingsFormLabelContainer>
                        <SettingsFormLabelLeftContainer>Cookie Consent Banner Accept Button Text</SettingsFormLabelLeftContainer>
                    </SettingsFormLabelContainer>
                    <SettingsFormInputContainer>
                    <FastField
                        name="cookie.accept_button_text"
                        render={({ field }: any) => (
                            <input {...field} value={field.value} />
                        )}
                    />
                    </SettingsFormInputContainer>
                </SettingsFormGroupInput>
            </SettingsFormGroup>}


            {(activeMobileMenu == 'terms-&-conditions' || activeMobileMenu == 'privacy-policy' || activeMobileMenu == 'cookie-policy') && 
            <SettingsActionButtonContainer>
                <SettingsActionButtonWrapper>
                    <button 
                        type="button" 
                        className='btn-cancel'
                        onClick={ () => store.setActiveMobileMenu(
                            store.activeMobileMenu.referrer.pop()!,
                            Array.from(new Set(store.activeMobileMenu.referrer))
                        )}>
                        Cancel
                    </button>
                    <button type="submit" disabled={isSubmitting}>
                        {isSubmitting && <RotateLoader size={2} color="white" />}
                        {!isSubmitting && "Save"}
                    </button>
            </SettingsActionButtonWrapper>
           </SettingsActionButtonContainer>}
           </>)}}

           </RestaurantForm>

       
        </div>
    )
}